import { render } from "./products-filter.vue?vue&type=template&id=0b178975"
import script from "./products-filter.vue?vue&type=script&lang=js"
export * from "./products-filter.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/maskingruppen-new/maskingruppen-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__